import React, { ReactElement } from 'react';
import { ShimmerVariants } from './style';
import { LoadingShimmer } from '@icarros/ids-react';

interface ShimmerWrapperProps {
  children?: ReactElement;
  type?: 'card';
}

export function ShimmerWrapper({ children, type }: ShimmerWrapperProps): JSX.Element {
  return (
    <ShimmerVariants type={type}>
      <LoadingShimmer show>{children}</LoadingShimmer>
    </ShimmerVariants>
  );
}
